import React, { useContext } from 'react';
import '../../../../api/ConversationResults';
import { PartnerCustomizationContext } from '../../Partners/symptom_check/PartnerCustomizations';
import '../../../clearstep/proto/results_pb';
import { THEME } from '../../../clearstep/util/Theme';
var getDollarsString = function (locationCost, partnerCost) {
    var cost = partnerCost !== null ? partnerCost : locationCost;
    var dollarsString = typeof cost === 'number' ? '$'.repeat(cost) : null;
    return dollarsString;
};
export var CareOptionCostIcon = function (props) {
    var _a, _b;
    var partnerCustomizations = useContext(PartnerCustomizationContext);
    var costEstimate = props.costEstimate, zipCode = props.zipCode, sourceOfCare = props.sourceOfCare, showCostEstimate = props.showCostEstimate, isTherapistSupported = props.isTherapistSupported, source = props.source;
    var careDetails = sourceOfCare.careDetails, locationCost = sourceOfCare.locationCost;
    var partnerCost = partnerCustomizations.careOptionCost({
        careType: sourceOfCare.careType,
        careDetails: careDetails,
        zipCode: zipCode,
        isTherapistSupported: isTherapistSupported,
        source: source,
    });
    var dollarsString = getDollarsString(locationCost, partnerCost);
    var careOptionCostIconStyling = 'text-grass w-24 text-right text-2.5xl leading-9 font-bold mobile:hidden';
    // Show the exact $ amount if we have the data & in cost estimate mode
    if (showCostEstimate && ((_a = costEstimate === null || costEstimate === void 0 ? void 0 : costEstimate.data) === null || _a === void 0 ? void 0 : _a.totalCost)) {
        return (React.createElement("span", { className: careOptionCostIconStyling }, 
        // eslint-disable-next-line react/jsx-no-literals
        "$".concat((_b = costEstimate === null || costEstimate === void 0 ? void 0 : costEstimate.data) === null || _b === void 0 ? void 0 : _b.totalCost.toFixed(0))));
    }
    // Show $$ repeated unless the partner hides this
    if (!THEME.symptomCheckCustomizations.hideCareOptionsCost) {
        return React.createElement("span", { className: careOptionCostIconStyling }, dollarsString);
    }
    // Or else show an empty span with styles for spacing
    return React.createElement("span", { className: careOptionCostIconStyling });
};
export default CareOptionCostIcon;
